var _style, _path, _path2, _path3, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEngIkona(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 142.3 65.8",
    style: {
      enableBackground: "new 0 0 142.3 65.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:6.56;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eng_ikona") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8,34.7H39.9V42h12.8v4.5H34.3V19.1h18.4v4.6H39.9v6.5h10.9V34.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3,46.6h-5.7l-11-18.1v18.1h-5.7V19.1h5.7l11,18.1V19.1h5.6V46.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.9,43.1c-1,1.2-2.5,2.2-4.3,2.8c-1.9,0.7-3.9,1-6.2,1c-2.4,0-4.5-0.5-6.3-1.6c-1.8-1-3.2-2.5-4.1-4.5s-1.5-4.3-1.5-7 v-1.9c0-2.7,0.5-5.1,1.4-7.1s2.3-3.5,4-4.6c1.7-1.1,3.8-1.6,6.1-1.6c3.3,0,5.8,0.8,7.6,2.3c1.8,1.6,2.9,3.8,3.3,6.8h-5.5 c-0.3-1.6-0.8-2.7-1.7-3.5s-2-1.1-3.6-1.1c-1.9,0-3.4,0.7-4.4,2.2c-1,1.4-1.5,3.6-1.5,6.5v1.8c0,2.9,0.5,5.1,1.6,6.5 c1.1,1.5,2.7,2.2,4.8,2.2c2.1,0,3.6-0.5,4.5-1.4v-4.7h-5.1v-4.2h10.8V43.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.3,
    y: 3.3,
    className: "st0",
    width: 135.8,
    height: 59.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngIkona);
export default __webpack_public_path__ + "static/media/eng_ikona.eeee0cc520a49ea86d41bc27df3786b4.svg";
export { ForwardRef as ReactComponent };